import {
  USER_FRUI_QPXH_MODAL_CHANGE,
} from './constants';

export function frui_qpxhModalChange(visible,type) {
  return {
    type: USER_FRUI_QPXH_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_FRUI_QPXH_MODAL_CHANGE:
      return {
        ...state,
        frui_qpxhModalType:action.data.type,
        frui_qpxhModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/frui_qpxhModalChange.js